import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Button } from '../ui/Button';

interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  links: { to: string; label: string }[];
}

export function MobileNav({ isOpen, onClose, links }: MobileNavProps) {
  const { isAuthenticated } = useAuth();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 md:hidden">
      <div className="absolute inset-0 bg-ink/40" onClick={onClose} />
      <div className="absolute right-0 top-0 h-full w-72 bg-paper p-6 shadow-stamp-lifted">
        <div className="mb-8 flex items-center justify-between">
          <span className="font-display text-lg font-bold text-seal-blue">Menu</span>
          <button onClick={onClose} aria-label="Close menu" className="text-ink/60">
            ✕
          </button>
        </div>
        <nav className="flex flex-col gap-5">
          {links.map((link) => (
            <Link key={link.to} to={link.to} onClick={onClose} className="text-lg font-medium text-ink">
              {link.label}
            </Link>
          ))}
        </nav>
        <div className="mt-8 stub-divider pt-6">
          <Link to={isAuthenticated ? '/dashboard' : '/login'} onClick={onClose}>
            <Button className="w-full">{isAuthenticated ? 'Dashboard' : 'Sign In'}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
